<template>
  <div>
    <div v-if="loadings > 0" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
    </div>
    <div class="d-flex" v-if="loadings == 0" >
      <feather-icon icon="UserIcon" size="19" />
      <h4 class="mb-0 ml-50">
        {{ $t('Link Device Attributes') }}
      </h4>
      <table-widget 
        :items="allItems"  
        :selected_ids="selectedItems"  
        :fields="fields"  
        link_type="deviceAttributes" 
        :link_to_id="deviceData.device_id" 
        title="title" 
      />
    </div>
  </div>

</template>

<script>

import {
  BButton, 
  BCol,
  BFormGroup,
  BFormInput,
  BInputGroup, 
  BInputGroupPrepend, 
  BRow, 
  BAlert,
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import { OrbitSpinner } from 'epic-spinners'
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import TableWidget from '@/views/widgets/TableWidget.vue';

import { ReportService } from '@/app/reports/share/report.service'

export default {
  props: {
    deviceData: {
      type: Object,
      required: true
    }
  },
  directives: {
    Ripple
  },
  components: {
    BRow,
    BCol,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BButton,
    vSelect,
    OrbitSpinner,
    TableWidget
  },
  setup(props, { root }) {
    
  const loadings = ref(2)
  const fields = ref([[{key:'id',label:'id'}]])
  const allItems = ref([]);
  const selectedItems = ref([]);

  ReportService.getAttributesOptions(
  ).then(response =>{
      allItems.value = response
      loadings.value--;
  })

  ReportService.getSelectedLinks({
    type:'deviceAttributes',
    deviceId:props.deviceData.device_id
  }).then(response => {
      selectedItems.value = response.ids
      loadings.value--;
  })

    return {
      allItems,
      fields,
      selectedItems,
      loadings,
    }
  }

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
